module.exports = __webpack_public_path__ + "img/btn_03_info.7ad91796.png";